import { Box, CircularProgress, CircularProgressLabel } from "@chakra-ui/react";
import { Link } from "@src/components/ui-kit";
import { WrapComponent } from "@src/utils/components/WrapComponent";
import { useStore } from "@src/utils/hooks";

interface InvoicedProps {
  percent: number;
  searchParam: string;
}

export const Invoiced = ({ percent, searchParam }: InvoicedProps) => {
  const { authStore } = useStore();
  return (
    <CircularProgress color="green.500" capIsRound value={percent / 100}>
      <CircularProgressLabel>
        <WrapComponent
          if={percent > 0 && authStore.isInternalUser}
          with={(children) => (
            <Link
              href={{
                pathname: "/invoices/outgoing-invoices",
                query: { search: searchParam },
              }}
            >
              {children}
            </Link>
          )}
        >
          <Box fontWeight="semibold">{percent / 100}%</Box>
        </WrapComponent>
      </CircularProgressLabel>
    </CircularProgress>
  );
};
